Object.defineProperty(exports,"__esModule",{value: true});
exports.default=window.GrimoireJS&&window.GrimoireJS.lib.fundamental?window.GrimoireJS.lib.fundamental.Geometry.Geometry:undefined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/grimoirejs-fundamental/ref/Geometry/Geometry.js
// module id = 27
// module chunks = 0